"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiKeyManager = exports.ApiKeyManagerImpl = exports.MAXIMUM_LOYALTY_CODES = exports.MAXIMUM_BONUSCODES = exports.LOYALTY_CODES_KEY_NAME = exports.BONUSCODES_KEY_NAME = exports.SESSION_KEY_NAME = exports.MASTER_KEY_NAME = exports.sessionTokenStorage = exports.masterTokenStorage = void 0;
var buffer_1 = require("buffer");
var runtime_1 = require("@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/runtime");
var SessionInvalidationMiddleware_1 = __importDefault(require("../SessionInvalidationMiddleware"));
var ApiKeyNotReadableError_1 = require("../errors/ApiKeyNotReadableError");
var setbonuscodenobonuscodes_1 = require("../errors/setbonuscodenobonuscodes");
var setbonuscodemaxreached_1 = require("../errors/setbonuscodemaxreached");
var setbonuscodealreadystored_1 = require("../errors/setbonuscodealreadystored");
var setloyaltycodealreadystored_1 = require("../errors/setloyaltycodealreadystored");
var setloyaltycodenoloyaltycodes_1 = require("../errors/setloyaltycodenoloyaltycodes");
var setloyaltycodemaxreached_1 = require("../errors/setloyaltycodemaxreached");
var fixFeatureUrlMiddleware_1 = __importDefault(require("../fixFeatureUrlMiddleware"));
var getPackageVersion_1 = __importDefault(require("../utils/getPackageVersion"));
var getLocale_1 = __importDefault(require("../utils/getLocale"));
var Bridge_1 = require("../Bridge");
var maxRetriesReached_1 = __importDefault(require("../errors/maxRetriesReached"));
var loginApiFactory_1 = __importDefault(require("./loginApiFactory"));
var apiHeaders_1 = require("../utils/apiHeaders");
var storage2 = require('storage2');
function wait(milliseconds) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, milliseconds); })];
        });
    });
}
// Original names MUST NOT be used (due to Safari issue)
exports.masterTokenStorage = storage2.localStorage;
exports.sessionTokenStorage = storage2.localStorage;
var bonuscodeTokenStorage = storage2.localStorage;
var loyaltyCodeTokenStorage = storage2.localStorage;
exports.MASTER_KEY_NAME = 'apiKey';
exports.SESSION_KEY_NAME = 'sessionKey';
exports.BONUSCODES_KEY_NAME = 'bonuscode';
exports.LOYALTY_CODES_KEY_NAME = 'loyaltyCode';
exports.MAXIMUM_BONUSCODES = 5;
exports.MAXIMUM_LOYALTY_CODES = 5;
var ApiKeyManagerImpl = /** @class */ (function () {
    function ApiKeyManagerImpl(oldInstance) {
        var _a;
        var _this = this;
        var _b;
        // Change on changed within that class
        this.subVersion = getPackageVersion_1.default;
        this.isApp = Bridge_1.bridge != null;
        this.data = {
            bonusCodes: [],
            loyaltyCodes: [],
            sessionChangedListener: [],
        };
        this.SYSTEMS = ['PRODUCTION', 'vtpipe', 'fit', 'mdt', 'mock', 'offline'];
        this.retryCount = 0;
        this.maxRetries = 3;
        this.getTokenContents = function (token) {
            try {
                var _a = token.split('.'), tokenPayloadBase64 = _a[1];
                var json = buffer_1.Buffer.from(tokenPayloadBase64, 'base64').toString('utf-8');
                var _b = JSON.parse(json), _c = _b.ctd, ts = _c.ts, type = _c.type, role = _c.role, ct = _c.ct, fi = _c.fi, cc = _c.cc, al = _c.al, np = _c.np, exp = _b.exp;
                return {
                    ts: ts != null ? _this.SYSTEMS[ts] : undefined,
                    type: type,
                    role: role,
                    ct: ct,
                    fi: fi,
                    cc: cc,
                    exp: exp,
                    al: al,
                    np: np,
                };
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                return undefined;
            }
        };
        this.getStoredBonusCodes = function () {
            var availableBonusCodes = [];
            var storedBonusCodes = Bridge_1.bridge && Bridge_1.bridge.getBonuscodes
                ? Bridge_1.bridge.getBonuscodes()
                : bonuscodeTokenStorage.getItem(exports.BONUSCODES_KEY_NAME);
            if (typeof storedBonusCodes === 'string' && storedBonusCodes) {
                availableBonusCodes = storedBonusCodes.split(':');
            }
            if (Array.isArray(storedBonusCodes)) {
                availableBonusCodes = storedBonusCodes;
            }
            return availableBonusCodes;
        };
        this.clearBonusCodes = function () {
            _this.data.bonusCodes = [];
            if (Bridge_1.bridge === null || Bridge_1.bridge === void 0 ? void 0 : Bridge_1.bridge.setBonuscodes) {
                Bridge_1.bridge.setBonuscodes('');
            }
            else {
                bonuscodeTokenStorage.setItem(exports.BONUSCODES_KEY_NAME, '');
                if (typeof window !== 'undefined') {
                    document.cookie = "".concat(exports.BONUSCODES_KEY_NAME, "=; Max-Age=0; path=/");
                }
            }
        };
        this.getStoredLoyaltyCodes = function () {
            var availableConflictBehavior;
            var availableLoyaltyCodes = [];
            var storedLoyaltyCodes = Bridge_1.bridge && Bridge_1.bridge.getLoyaltyCodes
                ? Bridge_1.bridge.getLoyaltyCodes()
                : loyaltyCodeTokenStorage.getItem(exports.LOYALTY_CODES_KEY_NAME);
            if (typeof storedLoyaltyCodes === 'string' && storedLoyaltyCodes) {
                if (storedLoyaltyCodes.indexOf('|') === -1) {
                    availableLoyaltyCodes = storedLoyaltyCodes.split(':');
                }
                else {
                    var _a = storedLoyaltyCodes.split('|'), loyaltyConflictBehaviorStr = _a[0], loyaltyCodesStr = _a[1];
                    if (loyaltyConflictBehaviorStr) {
                        availableConflictBehavior = loyaltyConflictBehaviorStr;
                    }
                    if (loyaltyCodesStr) {
                        availableLoyaltyCodes = loyaltyCodesStr.split(':');
                    }
                }
            }
            if (Array.isArray(storedLoyaltyCodes)) {
                availableLoyaltyCodes = storedLoyaltyCodes;
            }
            return {
                loyaltyConflictBehavior: availableConflictBehavior,
                loyaltyCodes: availableLoyaltyCodes,
            };
        };
        this.clearLoyaltyCodes = function () {
            _this.data.loyaltyCodes = [];
            if (Bridge_1.bridge === null || Bridge_1.bridge === void 0 ? void 0 : Bridge_1.bridge.setLoyaltyCodes) {
                Bridge_1.bridge.setLoyaltyCodes('');
            }
            else {
                loyaltyCodeTokenStorage.setItem(exports.LOYALTY_CODES_KEY_NAME, '');
                if (typeof window !== 'undefined') {
                    document.cookie = "".concat(exports.LOYALTY_CODES_KEY_NAME, "=; Max-Age=0; path=/");
                }
            }
        };
        this.ccBoxStyle = 'position: fixed; top: 0; left: 0; padding: 10px; background: rgba(100,255,100,.7); box-shadow: 0 0 5px rgba(0,0,0,0.3); z-index: 999; font-size: 20px; font-weight: bold;';
        this.ccBoxStyleActive = 'position: fixed; top: 0; left: 0; padding: 10px; background: rgba(255,255,100,.7); box-shadow: 0 0 5px rgba(0,0,0,0.3); z-index: 999; font-size: 20px; font-weight: bold;';
        this.boxStyle = 'position: fixed; top: 0; left: 47%; padding: 10px; background: rgba(255,128,128,.7); box-shadow: 0 0 5px rgba(0,0,0,0.3); z-index: 999; font-size: 20px; font-weight: bold;';
        this.visualizeSystem = function (token) {
            var _a = _this.getTokenContents(token) || {}, system = _a.ts, role = _a.role, type = _a.type;
            if (role === 1 || type === 6) {
                if (!_this.ccElement) {
                    var element = document.createElement('div');
                    document.body.insertBefore(element, document.body.firstChild);
                    _this.ccElement = element;
                }
                if (role === 1) {
                    _this.ccElement.setAttribute('style', _this.ccBoxStyle);
                    _this.ccElement.innerText = 'Callcenter - bereit';
                }
                else {
                    _this.ccElement.setAttribute('style', _this.ccBoxStyleActive);
                    _this.ccElement.innerText = 'Callcenter - aktiv';
                }
            }
            else if (_this.ccElement) {
                _this.ccElement.setAttribute('style', 'display: none;');
            }
            if (!system && !_this.systemElement) {
                return;
            }
            if (!_this.systemElement) {
                var element = document.createElement('div');
                document.body.insertBefore(element, document.body.firstChild);
                _this.systemElement = element;
            }
            if (system) {
                _this.systemElement.setAttribute('style', _this.boxStyle);
                _this.systemElement.innerText = "System: ".concat(system);
            }
            else {
                _this.systemElement.setAttribute('style', 'display: none;');
            }
        };
        this.addSessionChangedListener = function (sessionChangedListener) {
            _this.data.sessionChangedListener.push(sessionChangedListener);
            return function () {
                var index = _this.data.sessionChangedListener.indexOf(sessionChangedListener);
                if (index >= 0) {
                    _this.data.sessionChangedListener.splice(index, 1);
                }
            };
        };
        this.notifyListeners = function () {
            _this.data.sessionChangedListener.forEach(function (listener) { return listener(); });
        };
        this.invalidateSessionKey = function (oldKey) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // eslint-disable-next-line no-console
                // maybe that key was invalidated before - once is enough
                if (oldKey) {
                    if (oldKey !== this.data.sessionKey) {
                        return [2 /*return*/];
                    }
                }
                this.data.sessionKey = undefined;
                this.data.apiKeyPromise = undefined;
                if (Bridge_1.bridge) {
                    Bridge_1.bridge.setSessionToken('');
                }
                else {
                    exports.sessionTokenStorage.removeItem(exports.SESSION_KEY_NAME);
                }
                // eslint-disable-next-line no-console
                this.notifyListeners();
                return [2 /*return*/];
            });
        }); };
        this.logout = function (afterLogoutTokens) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!afterLogoutTokens) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setApiKeys(afterLogoutTokens)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.data.sessionKey = undefined;
                        this.data.masterKey = undefined;
                        this.data.apiKeyPromise = undefined;
                        if (Bridge_1.bridge) {
                            Bridge_1.bridge.setSessionToken('');
                            Bridge_1.bridge.setMasterToken('');
                        }
                        else {
                            exports.sessionTokenStorage.removeItem(exports.SESSION_KEY_NAME);
                            exports.masterTokenStorage.removeItem(exports.MASTER_KEY_NAME);
                        }
                        _a.label = 3;
                    case 3:
                        this.clearBonusCodes();
                        this.notifyListeners();
                        return [2 /*return*/];
                }
            });
        }); };
        this.saveBonuscodes = function () {
            var _a, _b;
            if (_this.data.bonusCodes.length === 0) {
                if (Bridge_1.bridge === null || Bridge_1.bridge === void 0 ? void 0 : Bridge_1.bridge.setBonuscodes) {
                    Bridge_1.bridge.setBonuscodes('');
                }
                else {
                    bonuscodeTokenStorage.removeItem(exports.BONUSCODES_KEY_NAME);
                    if (typeof window !== 'undefined') {
                        document.cookie = "".concat(exports.BONUSCODES_KEY_NAME, "=; Max-Age=0; path=/");
                    }
                }
                return;
            }
            var stringifiedCodes = _this.data.bonusCodes.join(':');
            if (Bridge_1.bridge === null || Bridge_1.bridge === void 0 ? void 0 : Bridge_1.bridge.setBonuscodes) {
                Bridge_1.bridge.setBonuscodes(stringifiedCodes);
            }
            else {
                bonuscodeTokenStorage.setItem(exports.BONUSCODES_KEY_NAME, stringifiedCodes);
                if (typeof window !== 'undefined') {
                    // if I am on client side store the bonus codes in a cookie for future server side renderings
                    var date = new Date();
                    // default - 6 hours
                    var expireTime = date.getTime() + 6 * 60 * 60;
                    // if I have a sessionKey use this expire time
                    if (_this.data.sessionKey) {
                        expireTime = (_b = (_a = _this.getTokenContents(_this.data.sessionKey)) === null || _a === void 0 ? void 0 : _a.exp) !== null && _b !== void 0 ? _b : expireTime;
                    }
                    date.setTime(expireTime * 1000);
                    var expires = "; expires=".concat(date.toISOString());
                    document.cookie = "".concat(exports.BONUSCODES_KEY_NAME, "=").concat(stringifiedCodes).concat(expires, "; path=/");
                }
            }
        };
        this.getBonuscodes = function () { return _this.data.bonusCodes && __spreadArray([], _this.data.bonusCodes, true); };
        this.setBonuscodes = function (inputBonuscodes, tenantId, overwrite) { return __awaiter(_this, void 0, void 0, function () {
            var bonuscodes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // make sure not to produce a race condition
                    // here we would like to set a bonus code
                    // but getApiKey(ByRest) deletes it when a new token is detected
                    // so first do the token magic and after that set the given bonuscode
                    return [4 /*yield*/, this.getApiKey({ tenantId: tenantId })];
                    case 1:
                        // make sure not to produce a race condition
                        // here we would like to set a bonus code
                        // but getApiKey(ByRest) deletes it when a new token is detected
                        // so first do the token magic and after that set the given bonuscode
                        _a.sent();
                        bonuscodes = overwrite
                            ? inputBonuscodes
                            : inputBonuscodes.filter(function (code) { return !_this.data.bonusCodes.includes(code); });
                        if (bonuscodes.length === 0) {
                            if (inputBonuscodes.length && !overwrite) {
                                // It were only duplicated codes
                                throw new setbonuscodealreadystored_1.SetBonuscodeAlreadyStoredError(this.data.bonusCodes, inputBonuscodes.filter(function (bonuscode) { return _this.data.bonusCodes.includes(bonuscode); }));
                            }
                            throw new setbonuscodenobonuscodes_1.SetBonuscodeNoBonuscodesError([], 'setBonuscodes called without bonuscodes to add');
                        }
                        if ((overwrite ? 0 : this.data.bonusCodes.length) + bonuscodes.length > exports.MAXIMUM_BONUSCODES) {
                            throw new setbonuscodemaxreached_1.SetBonuscodeMaxReachedError([], exports.MAXIMUM_BONUSCODES);
                        }
                        this.data.bonusCodes = overwrite ? bonuscodes : __spreadArray(__spreadArray([], this.data.bonusCodes, true), bonuscodes, true);
                        this.saveBonuscodes();
                        return [2 /*return*/];
                }
            });
        }); };
        this.removeBonuscodes = function (bonuscodes) { return __awaiter(_this, void 0, void 0, function () {
            var newBonuscodesForBasket;
            return __generator(this, function (_a) {
                if (bonuscodes.length === 0) {
                    throw new setbonuscodenobonuscodes_1.SetBonuscodeNoBonuscodesError([], 'removeBonuscodes called without bonuscodes to remove');
                }
                newBonuscodesForBasket = this.data.bonusCodes.filter(function (entry) {
                    return !bonuscodes.includes(entry);
                });
                this.data.bonusCodes = __spreadArray([], newBonuscodesForBasket, true);
                this.saveBonuscodes();
                return [2 /*return*/];
            });
        }); };
        this.saveLoyaltyCodes = function () {
            var _a, _b;
            if (!_this.data.loyaltyConflictBehavior && _this.data.loyaltyCodes.length === 0) {
                if (Bridge_1.bridge === null || Bridge_1.bridge === void 0 ? void 0 : Bridge_1.bridge.setLoyaltyCodes) {
                    Bridge_1.bridge.setLoyaltyCodes('');
                }
                else {
                    loyaltyCodeTokenStorage.removeItem(exports.LOYALTY_CODES_KEY_NAME);
                    if (typeof window !== 'undefined') {
                        document.cookie = "".concat(exports.LOYALTY_CODES_KEY_NAME, "=; Max-Age=0; path=/");
                    }
                }
                return;
            }
            var loyaltyCodesStr;
            if (_this.data.loyaltyConflictBehavior) {
                loyaltyCodesStr = "".concat(_this.data.loyaltyConflictBehavior, "|").concat(_this.data.loyaltyCodes.join(':'));
            }
            else {
                loyaltyCodesStr = _this.data.loyaltyCodes.join(':');
            }
            if (Bridge_1.bridge === null || Bridge_1.bridge === void 0 ? void 0 : Bridge_1.bridge.setLoyaltyCodes) {
                Bridge_1.bridge.setLoyaltyCodes(loyaltyCodesStr);
            }
            else {
                loyaltyCodeTokenStorage.setItem(exports.LOYALTY_CODES_KEY_NAME, loyaltyCodesStr);
                if (typeof window !== 'undefined') {
                    // if I am on client side store the bonus codes in a cookie for future server side renderings
                    var date = new Date();
                    // default - 6 hours
                    var expireTime = date.getTime() + 6 * 60 * 60;
                    // if I have a sessionKey use this expire time
                    if (_this.data.sessionKey) {
                        expireTime = (_b = (_a = _this.getTokenContents(_this.data.sessionKey)) === null || _a === void 0 ? void 0 : _a.exp) !== null && _b !== void 0 ? _b : expireTime;
                    }
                    date.setTime(expireTime * 1000);
                    var expires = "; expires=".concat(date.toISOString());
                    document.cookie = "".concat(exports.LOYALTY_CODES_KEY_NAME, "=").concat(loyaltyCodesStr).concat(expires, "; path=/");
                }
            }
        };
        this.getLoyaltyConflictBehavior = function () { return _this.data.loyaltyConflictBehavior; };
        this.setLoyaltyConflictBehavior = function (loyaltyConflictBehavior) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.data.loyaltyConflictBehavior = loyaltyConflictBehavior;
                this.saveLoyaltyCodes();
                return [2 /*return*/];
            });
        }); };
        this.getLoyaltyCodes = function () { return _this.data.loyaltyCodes && __spreadArray([], _this.data.loyaltyCodes, true); };
        this.setLoyaltyCodes = function (inputLoyaltyCodes, overwrite) { return __awaiter(_this, void 0, void 0, function () {
            var loyaltyCodes;
            var _this = this;
            return __generator(this, function (_a) {
                loyaltyCodes = overwrite
                    ? inputLoyaltyCodes
                    : inputLoyaltyCodes.filter(function (code) { return !_this.data.loyaltyCodes.includes(code); });
                if (loyaltyCodes.length === 0) {
                    if (inputLoyaltyCodes.length && !overwrite) {
                        // It were only duplicated codes
                        throw new setloyaltycodealreadystored_1.SetLoyaltyCodeAlreadyStoredError(this.data.loyaltyCodes, inputLoyaltyCodes.filter(function (code) { return _this.data.loyaltyCodes.includes(code); }));
                    }
                    throw new setloyaltycodenoloyaltycodes_1.SetLoyaltyCodeNoLoyaltyCodesError([], 'setLoyaltyCodes called without loyalty codes to add');
                }
                if ((overwrite ? 0 : this.data.loyaltyCodes.length) + loyaltyCodes.length >
                    exports.MAXIMUM_LOYALTY_CODES) {
                    throw new setloyaltycodemaxreached_1.SetLoyaltyCodeMaxReachedError([], exports.MAXIMUM_LOYALTY_CODES);
                }
                this.data.loyaltyCodes = overwrite
                    ? loyaltyCodes
                    : __spreadArray(__spreadArray([], this.data.loyaltyCodes, true), loyaltyCodes, true);
                this.saveLoyaltyCodes();
                return [2 /*return*/];
            });
        }); };
        this.removeLoyaltyCodes = function (loyaltyCodes) { return __awaiter(_this, void 0, void 0, function () {
            var newLoyaltyCodesForBasket;
            return __generator(this, function (_a) {
                if (loyaltyCodes.length === 0) {
                    throw new setloyaltycodenoloyaltycodes_1.SetLoyaltyCodeNoLoyaltyCodesError([], 'removeLoyaltyCodes called without loyalty codes to remove');
                }
                newLoyaltyCodesForBasket = this.data.loyaltyCodes.filter(function (entry) {
                    return !loyaltyCodes.includes(entry);
                });
                this.data.loyaltyCodes = __spreadArray([], newLoyaltyCodesForBasket, true);
                this.saveLoyaltyCodes();
                return [2 /*return*/];
            });
        }); };
        this.setApiKeys = function (tokens, customer) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.data.sessionKey = tokens.sessionToken;
                if (Bridge_1.bridge) {
                    Bridge_1.bridge.setSessionToken(this.data.sessionKey);
                }
                else {
                    exports.sessionTokenStorage.setItem(exports.SESSION_KEY_NAME, this.data.sessionKey);
                    this.setLoginInfoCookie(tokens, customer);
                }
                this.visualizeSystem(this.data.sessionKey);
                if (tokens.masterToken) {
                    this.data.masterKey = tokens.masterToken;
                    if (Bridge_1.bridge) {
                        Bridge_1.bridge.setMasterToken(this.data.masterKey);
                    }
                    else {
                        exports.masterTokenStorage.setItem(exports.MASTER_KEY_NAME, this.data.masterKey);
                    }
                }
                this.data.apiKeyPromise = undefined;
                this.notifyListeners();
                return [2 /*return*/];
            });
        }); };
        this.getApiKeyByRest = function (forceNewAnonymous, system, retryCount, maxRetries, tenantId) {
            if (forceNewAnonymous === void 0) { forceNewAnonymous = false; }
            if (retryCount === void 0) { retryCount = _this.retryCount; }
            if (maxRetries === void 0) { maxRetries = _this.maxRetries; }
            if (tenantId === void 0) { tenantId = ''; }
            return __awaiter(_this, void 0, void 0, function () {
                var fiValue, generatedApiHeaders, loginApi, ecLocale, tokens, ignore_1;
                var _this = this;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (retryCount > maxRetries) {
                                throw new maxRetriesReached_1.default();
                            }
                            fiValue = (_b = this.getTokenContents((_a = this.data.sessionKey) !== null && _a !== void 0 ? _a : '')) === null || _b === void 0 ? void 0 : _b.fi;
                            generatedApiHeaders = (0, apiHeaders_1.generateApiHeaders)({
                                tenant: tenantId,
                                fi: fiValue !== null && fiValue !== void 0 ? fiValue : '',
                            });
                            loginApi = (0, loginApiFactory_1.default)(new runtime_1.Configuration({
                                middleware: [
                                    new SessionInvalidationMiddleware_1.default(function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!this.data.masterKey) return [3 /*break*/, 2];
                                                    // If a master key was provided, it is invalid; delete it, and get a anonymous token
                                                    this.data.masterKey = undefined;
                                                    if (Bridge_1.bridge) {
                                                        Bridge_1.bridge.setMasterToken('');
                                                    }
                                                    else {
                                                        exports.masterTokenStorage.removeItem(exports.MASTER_KEY_NAME);
                                                    }
                                                    this.retryCount += 1;
                                                    return [4 /*yield*/, this.getApiKeyByRest(forceNewAnonymous, system, this.retryCount, this.maxRetries, tenantId)];
                                                case 1:
                                                    _a.sent();
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); }),
                                    new fixFeatureUrlMiddleware_1.default('feature-backend-customer'),
                                ],
                                basePath: runtime_1.BASE_PATH.replace(/^https?:\/\/[^/]*/, ''),
                                apiKey: this.data.masterKey,
                            }));
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 5]);
                            this.clearBonusCodes();
                            this.clearLoyaltyCodes();
                            ecLocale = (0, getLocale_1.default)();
                            return [4 /*yield*/, (this.data.masterKey && !forceNewAnonymous
                                    ? loginApi.getReturningUsersToken({
                                        ecLocale: ecLocale,
                                        xEcHfi: generatedApiHeaders['x-ec-hfi'],
                                        xEcHmac: generatedApiHeaders['x-ec-hmac'],
                                        xEcTimestamp: generatedApiHeaders['x-ec-timestamp'],
                                    })
                                    : loginApi.getAnonymousToken({
                                        ecLocale: ecLocale,
                                        xEcSystem: system,
                                        xEcHfi: generatedApiHeaders['x-ec-hfi'],
                                        xEcHmac: generatedApiHeaders['x-ec-hmac'],
                                        xEcTimestamp: generatedApiHeaders['x-ec-timestamp'],
                                    }))];
                        case 2:
                            tokens = _c.sent();
                            if (tokens.masterToken) {
                                this.data.masterKey = tokens.masterToken;
                                if (Bridge_1.bridge) {
                                    Bridge_1.bridge.setMasterToken(this.data.masterKey);
                                }
                                else {
                                    exports.masterTokenStorage.setItem(exports.MASTER_KEY_NAME, this.data.masterKey);
                                }
                            }
                            this.data.sessionKey = tokens.sessionToken;
                            if (Bridge_1.bridge) {
                                Bridge_1.bridge.setSessionToken(this.data.sessionKey);
                            }
                            else {
                                exports.sessionTokenStorage.setItem(exports.SESSION_KEY_NAME, this.data.sessionKey);
                                this.setLoginInfoCookie(tokens);
                            }
                            this.data.apiKeyPromise = undefined;
                            this.visualizeSystem(this.data.sessionKey);
                            this.retryCount = 0;
                            return [3 /*break*/, 5];
                        case 3:
                            ignore_1 = _c.sent();
                            // this is to exclude an endless loop
                            // https://empiriecom.atlassian.net/browse/ORDER-3283
                            return [4 /*yield*/, wait(500)];
                        case 4:
                            // this is to exclude an endless loop
                            // https://empiriecom.atlassian.net/browse/ORDER-3283
                            _c.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        this.getApiKey = function (_a) {
            var tenantId = _a.tenantId;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_b) {
                    if (!this.data.apiKeyPromise) {
                        if (this.data.sessionKey) {
                            this.data.apiKeyPromise = Promise.resolve(this.data.sessionKey);
                        }
                        else {
                            this.data.apiKeyPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                                var _e_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 4]);
                                            return [4 /*yield*/, this.getApiKeyByRest(undefined, undefined, this.retryCount, this.maxRetries, tenantId)];
                                        case 1:
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 2:
                                            _e_1 = _a.sent();
                                            // this is to exclude an endless loop
                                            // https://empiriecom.atlassian.net/browse/ORDER-3283
                                            return [4 /*yield*/, wait(500)];
                                        case 3:
                                            // this is to exclude an endless loop
                                            // https://empiriecom.atlassian.net/browse/ORDER-3283
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (!this.data.sessionKey) {
                                                throw new ApiKeyNotReadableError_1.ApiKeyNotReadableError();
                                            }
                                            return [2 /*return*/, this.data.sessionKey];
                                    }
                                });
                            }); })();
                        }
                    }
                    return [2 /*return*/, this.data.apiKeyPromise];
                });
            });
        };
        this.sessionInvalidationMiddleware = new SessionInvalidationMiddleware_1.default(function (oldKey) { return _this.invalidateSessionKey(oldKey); });
        this.useSystem = function (tenantId, system) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApiKeyByRest(true, system, this.retryCount, this.maxRetries, tenantId)];
                    case 1:
                        _a.sent();
                        this.notifyListeners();
                        return [2 /*return*/];
                }
            });
        }); };
        this.data.masterKey = Bridge_1.bridge
            ? Bridge_1.bridge.getMasterToken()
            : exports.masterTokenStorage.getItem(exports.MASTER_KEY_NAME);
        this.data.sessionKey = Bridge_1.bridge
            ? Bridge_1.bridge.getSessionToken()
            : exports.sessionTokenStorage.getItem(exports.SESSION_KEY_NAME);
        this.data.bonusCodes = this.getStoredBonusCodes();
        var _c = this.getStoredLoyaltyCodes(), loyaltyConflictBehavior = _c.loyaltyConflictBehavior, loyaltyCodes = _c.loyaltyCodes;
        this.data.loyaltyConflictBehavior = loyaltyConflictBehavior;
        this.data.loyaltyCodes = loyaltyCodes;
        if (this.data.sessionKey) {
            this.visualizeSystem(this.data.sessionKey);
        }
        if (!this.data.masterKey && !this.data.sessionKey && process.env.NODE_ENV === 'test') {
            this.data.sessionKey = 'SESSION-KEY';
            this.data.masterKey = 'MASTER-KEY';
        }
        // No window, nothing happens. So ignore it
        // istanbul ignore else
        if (typeof window !== 'undefined' && !Bridge_1.bridge) {
            window.addEventListener('storage', function (e) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(e.key === exports.SESSION_KEY_NAME && e.storageArea === exports.sessionTokenStorage)) return [3 /*break*/, 3];
                            if (!(e.newValue && e.newValue !== this.data.sessionKey)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.setApiKeys({
                                    sessionToken: e.newValue,
                                })];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [3 /*break*/, 4];
                        case 3:
                            if (e.key === exports.MASTER_KEY_NAME && e.storageArea === exports.masterTokenStorage) {
                                // No window, nothing happens. So ignore it
                                // istanbul ignore else
                                if (e.newValue && e.newValue !== this.data.masterKey) {
                                    this.data.masterKey = e.newValue;
                                }
                            }
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        }
        if (oldInstance) {
            var oldListeners = oldInstance.sessionChangedListener || ((_b = oldInstance.data) === null || _b === void 0 ? void 0 : _b.sessionChangedListener);
            (_a = this.data.sessionChangedListener).push.apply(_a, oldListeners);
            // BIND functions to new this, and copy all properties
            var myself_1 = this;
            Object.keys(myself_1).forEach(function (key) {
                var value = myself_1[key];
                // eslint-disable-next-line no-param-reassign
                oldInstance[key] =
                    typeof value === 'function' ? function () {
                        var _a;
                        var params = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            params[_i] = arguments[_i];
                        }
                        return (_a = myself_1)[key].apply(_a, params);
                    } : value;
            });
            // We notify all old ones - they may have an incorrect token
            oldListeners.forEach(function (listener) {
                listener();
            });
        }
    }
    /**
     * Sets specific customer data to the cookie "ecState" (clientside only)
     *
     * The cookie's value is a stringified object encoded with encodeURIComponent
     * Example object: {li: "1", bop:"1", ca: "0"}
     * In Cookie: %7B%22li%22%3A%221%22%2C%22bop%22%3A%221%22%2C%22ca%22%3A%220%22%7D
     *
     */
    ApiKeyManagerImpl.prototype.setLoginInfoCookie = function (tokens, customer) {
        var _a, _b, _c, _d, _f, _g, _h;
        if (typeof window !== 'undefined') {
            var cookieName_1 = 'ecState';
            var tokenContents = this.getTokenContents(tokens.sessionToken);
            var date = new Date();
            var type = (_a = tokenContents === null || tokenContents === void 0 ? void 0 : tokenContents.type) !== null && _a !== void 0 ? _a : 0;
            var autologin = (_b = tokenContents === null || tokenContents === void 0 ? void 0 : tokenContents.al) !== null && _b !== void 0 ? _b : 0;
            var exp = (_c = tokenContents === null || tokenContents === void 0 ? void 0 : tokenContents.exp) !== null && _c !== void 0 ? _c : 0;
            var np = (_d = tokenContents === null || tokenContents === void 0 ? void 0 : tokenContents.np) !== null && _d !== void 0 ? _d : 0;
            var loggedIn = type >= 1;
            if (autologin === 1) {
                // Autologin - 10 years
                date.setTime(date.getTime() + 3650 * 24 * 60 * 60 * 1000);
            }
            else {
                // all others - jwt expiration
                date.setTime(exp * 1000);
            }
            // default value for logged out
            var valuesToSet = { li: '0' };
            // if we are logged in, we gather the values from customer
            if (loggedIn) {
                var bop = '0';
                var ca = '0';
                // preferably use values from given customer object
                if (customer) {
                    bop = ((_f = customer.extra) === null || _f === void 0 ? void 0 : _f.bop) === '1' ? '1' : '0';
                    ca = ((_g = customer.extra) === null || _g === void 0 ? void 0 : _g.ca) === '1' ? '1' : '0';
                }
                else {
                    // if no customer was given, we try to gather existing data from a previously set cookie
                    try {
                        /** Get currently set cookie data */
                        var existingCookieData = void 0;
                        var currentCookieValue = (_h = document.cookie
                            .split(';')
                            .map(function (rawCookieString) { return rawCookieString.split('='); })
                            .find(function (_a) {
                            var name = _a[0];
                            return name.trim() === cookieName_1;
                        })) === null || _h === void 0 ? void 0 : _h[1];
                        if (currentCookieValue) {
                            existingCookieData = JSON.parse(decodeURIComponent(currentCookieValue));
                            bop = 'bop' in existingCookieData ? existingCookieData.bop : '0';
                            ca = 'ca' in existingCookieData ? existingCookieData.ca : '0';
                        }
                    }
                    catch (_j) {
                        // catch possible errors if cookie string was malformed
                    }
                }
                // our object for a logged in customer
                valuesToSet = {
                    li: '1',
                    bop: bop,
                    ca: ca,
                    np: np ? '1' : '0',
                };
            }
            // stringify and encode data object
            var cookieString = encodeURIComponent(JSON.stringify(valuesToSet));
            var isTestEnv = process.env.NODE_ENV === 'test';
            var secureFlag = isTestEnv ? '' : '; secure';
            // Set cookie
            document.cookie = "".concat(cookieName_1, "=").concat(cookieString, "; expires=").concat(date.toISOString(), "; path=/").concat(secureFlag);
        }
    };
    return ApiKeyManagerImpl;
}());
exports.ApiKeyManagerImpl = ApiKeyManagerImpl;
// No window, nothing happens. So ignore it.
// istanbul ignore else
if (typeof window !== 'undefined') {
    if (!((_a = window.apiKeyManagerV1) === null || _a === void 0 ? void 0 : _a.subVersion) ||
        window.apiKeyManagerV1.subVersion < getPackageVersion_1.default) {
        window.apiKeyManagerV1 = new ApiKeyManagerImpl(window.apiKeyManagerV1);
    }
}
// in case of Backend: we just use a new instance, it will be called only once
// (no multiple fragments in a node instance)
exports.apiKeyManager = typeof window !== 'undefined'
    ? window.apiKeyManagerV1
    : new ApiKeyManagerImpl();
//# sourceMappingURL=index.js.map